export function getThumbnailUrl(imageUrl) {
    return imageUrl.replace(/(\.[\w\d_-]+)$/i, '_tn$1');
}